import React from 'react'
import PropTypes from 'prop-types'
import { Route, Redirect } from 'react-router-dom'

export const PrivateRoute = ({ component: Component, ...rest }) => {
    return (
        <Route {...rest} render={props => {
            const user = JSON.parse(sessionStorage.getItem('user'))
            return (
                user
                    ? rest.adminOnly && user.userName === 'admin' ? <Component {...props} />
                        : rest.adminOnly && user.userName !== 'admin' ? <Redirect to={{ pathname: '/', state: { from: props.location } }} />
                            : <Component {...props} />
                    : <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
            )
        }} />
    )
}

PrivateRoute.propTypes = {
    component: PropTypes.any,
    location: PropTypes.object
}